// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'product';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='m2.813 17.438-1.5-1.89a3.375 3.375 0 0 1-.75-2.108V9.563a1.125 1.125 0 1 1 2.25 0v2.91' />
    <path d='M6.187 17.332v-2.25a3.323 3.323 0 0 0-.57-1.867l-.855-1.29a1.059 1.059 0 0 0-1.93.275 1.05 1.05 0 0 0 .078.738l1.027 1.687m11.251 2.813 1.5-1.89c.482-.597.746-1.34.75-2.108V9.563a1.125 1.125 0 1 0-2.25 0v2.91' />
    <path d='M11.813 17.332v-2.25a3.323 3.323 0 0 1 .57-1.867l.855-1.29a1.058 1.058 0 0 1 1.93.275c.064.247.037.51-.078.738l-1.027 1.687M9 .563 4.5 3.135 9 5.707l4.5-2.572zm-3.375 9L9 11.49V5.708L4.5 3.135v4.178m7.875 2.25L9 11.49V5.708l4.5-2.573v4.178' />
  </g>
);

export const viewBox = '0 0 18 18';
